import { Button } from '@mui/material'
import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { CheckBox, FastForward } from '@mui/icons-material'

function StudyDataSelectToggle() {
  const navigate = useNavigate()
  const location = useLocation()
  if (location.pathname.endsWith('resume')) {
    return (
      <Button
        onClick={() => {
          navigate(`../select`)
        }}
        variant={'outlined'}
        endIcon={<CheckBox />}
      >
        New Entry
      </Button>
    )
  } else {
    return (
      <Button
        onClick={() => {
          navigate(`resume`)
        }}
        variant={'outlined'}
        endIcon={<FastForward />}
      >
        Resume Entry
      </Button>
    )
  }
}

export default StudyDataSelectToggle
